import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=46e126d0&scoped=true"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e126d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitrix/ext_www/igr.ru/local/templates/main/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46e126d0')) {
      api.createRecord('46e126d0', component.options)
    } else {
      api.reload('46e126d0', component.options)
    }
    module.hot.accept("./Breadcrumbs.vue?vue&type=template&id=46e126d0&scoped=true", function () {
      api.rerender('46e126d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Breadcrumbs.vue"
export default component.exports